import React, { useEffect, useState } from 'react';
import { Container } from '@material-ui/core';
import { dateToLocal, handleError, handleErrorToast } from '../shared/Functions';
import SendIcon from '@material-ui/icons/Send';
import { AutoPaysVService } from '../../services/V2/gozer/services/AutoPaysVService';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { useHistory } from 'react-router';
import { authProvider } from '../../services/Security';
import { DistrictsVService } from '../../services/V2/padre';
import { HttpTransportType, HubConnectionBuilder } from '@microsoft/signalr';
import GetAppIcon from '@material-ui/icons/GetApp';
import { getAutoPaymentBatch, getAutoPayments } from '../shared/ExportFunctions';
import { CustomTable } from '../shared/CustomTable';

export const AutoPay = ({ errorToast, successToast }) => {
    const history = useHistory();
    const [connection, setConnection] = useState<any>(null);
    const [districtId, setDistrictId] = useState<string>();
    const [district, setDistrict] = useState<any>();
    const [token, setToken] = useState<any>();
    const [disablePayments, setDisablePayments] = useState<any>();
    const [loading, setLoading] = useState<any>();

    window.addEventListener('message', event => {
        // IMPORTANT: check the origin of the data!
        if (!event.data) return;
        var data = JSON.parse(event?.data);
        authProvider.setToken(data?.token)
        setDistrictId(data?.districtId)
        setToken(data?.token)
        // if (event.origin === 'https://your-first-site.example') {
        //     // The data was sent from your site.
        //     // Data sent with postMessage is stored in event.data:
        // } else {
        //     // The data was NOT sent from your site!
        //     // Be careful! Do not use it. This else branch is
        //     // here just for clarity, you usually shouldn't need it.
        //     return;
        // }
    });

    useEffect(() => {
        if (!token || !districtId) return;
        DistrictsVService.districtsVGetById(districtId ?? "")
            .then(x => setDistrict(x))
            .catch(x => handleError(x))
    }, [token, districtId])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const newConnection = new HubConnectionBuilder()
            .withUrl(`${process.env.GOZER_HOST}/hub/RecurringPayments`, {
                skipNegotiation: true,
                transport: HttpTransportType.WebSockets
            })
            .withAutomaticReconnect()
            .build();
        setConnection(newConnection);
    }, []);

    useEffect(() => {
        if (connection && district) {
            connection.start()
                .then(result => {
                    connection.on('RecurringMessage', message => {
                        var data = message
                        if (data.districtId !== district.id) return;
                        if (!data) errorToast("Something Failed.")
                        else if (!data.id) errorToast(data.message)
                        else {
                            successToast(`Success! ${data.successes} succeeded, ${data.failures} failed.`)
                            history.replace(`/app/autopay/${data.id}`)
                        }
                    });
                })
                .catch(e => console.log('Connection failed: ', e));
        }
    }, [connection, district]);// eslint-disable-line react-hooks/exhaustive-deps

    const runAutoPay = (autopayId, batchId) => {
        let confirm = window.confirm(`Are you sure you want to run Recurring Payments for Batch ${batchId}?`);

        if (confirm === true) {
            setDisablePayments(true)
            AutoPaysVService.autoPaysVPostAutoPay(autopayId)
                .then(x => {
                    successToast(`Running. You can leave the page and come back for results or wait here and be redirected once they come in.`)
                })
                .catch(x => errorToast(handleErrorToast(x)))
        }
    }

    const rerunAutoPay = (paymentId, batchId) => {
        let confirm = window.confirm(`Are you sure you want to rerun Recurring Payments for all failed Billing Account payments in Batch ${batchId}?`);

        if (confirm === true) {
            setDisablePayments(true)
            AutoPaysVService.autoPaysVRerunFailedPayments(paymentId)
                .then(x => {
                    successToast(`Running. You can leave the page and come back for results or wait here and be redirected once they come in.`)
                })
                .catch(x => errorToast(handleErrorToast(x)))
        }
    }

    const createBatch = () => {
        AutoPaysVService.autoPaysVCreateBatch(district.id)
            .then(x => {
                successToast(`Batch Created.`)
                history.replace(`/app/autopay/${x.id}/batch`)
            })
            .catch(x => errorToast(handleErrorToast(x)))
    }

    const handleDownload = (id, date, getBatch) => {
        if (getBatch) {
            getAutoPaymentBatch(id, date)
                .then(x => { })
                .catch(err => handleError(err))
        } else {
            getAutoPayments(id, date)
                .then(x => console.log(x))
                .catch(err => handleError(err))
        }
    }

    return (
        <React.Fragment>
            <Container maxWidth="xl">
                <div style={{ backgroundColor: "white", borderRadius: "10px" }}>
                    <CustomTable
                        title="Recurring Payments"
                        columns={[
                            { title: 'Batch Id', field: 'batchId', editable: 'never' },
                            { title: 'Has Error', field: 'error', editable: 'never', render: rowData => rowData.error ? "Yes. Please contact support." : "No" },
                            { title: 'Has Been Run', field: 'hasBeenRun', type: 'boolean', editable: 'never' },
                            { title: 'Run Date', field: 'runDate', editable: 'never', render: rowData => rowData.runDate ? dateToLocal(rowData.runDate).toLocaleString() : null },
                            { title: 'Has Been ReRun', field: 'hasBeenRerun', type: 'boolean', editable: 'never' },
                            { title: 'ReRun Date', field: 'reRunDate', editable: 'never', render: rowData => rowData.reRunDate ? dateToLocal(rowData.reRunDate).toLocaleString() : null },
                            { title: 'Approved Payments', field: 'successes', editable: 'never' },
                            { title: 'Error Payments', field: 'failures', editable: 'never' },
                            { title: 'Declined Payments', field: 'declines', editable: 'never' },
                            { title: 'Total Count', field: 'batchCount', editable: 'never' },
                            { title: 'Total Value', field: 'batchAmount', editable: 'never' },
                        ]}
                        dataEndpoint={(query: any) => {
                            return new Promise((resolve, reject) => {
                                if (!districtId) resolve({
                                    data: [],
                                    page: query.page,
                                    totalCount: 0
                                });

                                else
                                    AutoPaysVService.autoPaysVGetAll({
                                        pageNumber: query.page + 1,
                                        numberPerPage: query.pageSize,
                                        orderBy: query?.orderBy?.field?.toString() ?? "CreatedAt",
                                        orderByDesc: (query.orderDirection === "" ? true : query.orderDirection === "desc"),
                                        filters: [{ property: "DistrictId", value: districtId }],
                                        searchQuery: query.search
                                    }).then((x: any) => {
                                        resolve({
                                            data: x.items ?? [],
                                            page: query.page,
                                            totalCount: x.numberOfItems ?? 0
                                        });
                                    }).catch(x => {
                                        reject(x);
                                    });
                            });
                        }}
                        actions={[
                            {
                                icon: 'refresh',
                                tooltip: 'Refresh Data',
                                isFreeAction: true,
                                onClick: () => { setLoading(true); },
                            },
                            {
                                icon: () => <SendIcon />,
                                tooltip: 'Create Batch',
                                isFreeAction: true,
                                onClick: () => createBatch()
                            },
                            rowData => ({
                                icon: () => <SendIcon />,
                                tooltip: "Submit Batch Payments",
                                onClick: (e, rowData: any) => runAutoPay(rowData.id, rowData.batchId),
                                disabled: disablePayments || rowData.hasBeenRun
                            }),
                            rowData => ({
                                icon: () => <SendIcon />,
                                tooltip: "ReSubmit Failed Payments",
                                onClick: (e, rowData: any) => rerunAutoPay(rowData.id, rowData.batchId),
                                disabled: disablePayments || rowData.hasBeenRerun || !rowData.hasBeenRun || rowData.failures === 0
                            }),
                            {
                                icon: () => <GetAppIcon />,
                                tooltip: "Export",
                                onClick: (e, rowData: any) => handleDownload(rowData.id, dateToLocal(rowData.createdAt).toLocaleString(), !rowData.hasBeenRun),
                                // disabled: !
                            },
                            {
                                icon: () => <VisibilityIcon />,
                                tooltip: "View",
                                onClick: (e, rowData: any) => !rowData.hasBeenRun ? history.replace(`/app/autopay/${rowData.id}/batch`) : history.replace(`/app/autopay/${rowData.id}`),
                                // disabled: !
                            }
                        ]}
                        refresh={loading} setRefresh={setLoading} dataSet={null} pageSize={15} enablePaging={true}
                        districtId={districtId} addedQuery={null} hiddenColumns={[]} setHiddenColumns={() => { }} hiddenColumnsDisabled={true}
                        tableHeight={"400px"} enableSearch={false} searchPlaceholder={null}
                    />
                </div>
            </Container>
        </React.Fragment>
    );
}
